import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['file', 'startButton', 'stopButton', 'clearButton', 'preview', 'status']

  disconnect() {
    this.stream?.getTracks().forEach((track) => track.stop())
  }

  async start() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    } catch (error) {
      this.statusTarget.textContent = 'Microphone access was blocked'
      return
    }

    this.chunks = []
    this.recorder = new MediaRecorder(this.stream)
    this.recorder.addEventListener('dataavailable', (event) => this.chunks.push(event.data))
    this.recorder.addEventListener('stop', () => this.finishRecording())
    this.recorder.start()

    this.startButtonTarget.classList.add('hidden')
    this.stopButtonTarget.classList.remove('hidden')
    this.previewTarget.classList.add('hidden')
    this.clearButtonTarget.classList.add('hidden')
    this.statusTarget.textContent = 'Recording…'
  }

  stop() {
    this.recorder?.stop()
  }

  finishRecording() {
    this.stream.getTracks().forEach((track) => track.stop())
    this.recording = new Blob(this.chunks, { type: this.recorder.mimeType })
    this.previewTarget.src = URL.createObjectURL(this.recording)
    this.previewTarget.classList.remove('hidden')
    this.stopButtonTarget.classList.add('hidden')
    this.startButtonTarget.classList.remove('hidden')
    this.startButtonTarget.textContent = 'Re-record'
    this.clearButtonTarget.classList.remove('hidden')
    this.statusTarget.textContent = 'Recorded. Listen back, then save.'
  }

  clear() {
    URL.revokeObjectURL(this.previewTarget.src)
    this.recording = null
    this.previewTarget.removeAttribute('src')
    this.previewTarget.classList.add('hidden')
    this.clearButtonTarget.classList.add('hidden')
    this.startButtonTarget.textContent = 'Record'
    this.statusTarget.textContent = ''
  }

  attachRecording() {
    if (!this.recording || this.fileTarget.files.length > 0) return

    const extension = this.recording.type.includes('mp4') ? 'mp4' : 'webm'
    const file = new File([this.recording], `recording.${extension}`, { type: this.recording.type })
    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.fileTarget.files = transfer.files
  }
}
